// A button that flips a class on <html> and remembers the choice, for panels
// whose open/closed state is the user's preference rather than page state.
//
// Same shape as `SidebarCollapse`, but data-attribute driven so any page can use
// it, and two-way rather than force-on like `CollapseSidebar`. The class goes on
// <html> deliberately: an attribute on a LiveView-rendered element is the
// server's to own, and a DOM patch would drop or fight a value the server never
// rendered.
//
//   <button phx-hook="PersistedToggle"
//           data-toggle-class="facets-collapsed"
//           data-storage-key="sidecar-facets-collapsed" />
export const PersistedToggle = {
  mounted() {
    const className = this.el.dataset.toggleClass;
    const storageKey = this.el.dataset.storageKey || className;

    const on = () => document.documentElement.classList.contains(className);

    this.apply = (collapsed) => {
      document.documentElement.classList.toggle(className, collapsed);
      // The button reveals the panel, so it is expanded when *not* collapsed.
      this.el.setAttribute("aria-expanded", String(!collapsed));
      try {
        localStorage.setItem(storageKey, collapsed ? "true" : "false");
      } catch {
        // localStorage may be unavailable (e.g. private mode); ignore.
      }
    };

    let stored = null;
    try {
      stored = localStorage.getItem(storageKey);
    } catch {
      // ignore
    }

    // Only a stored choice moves the class; without one, whatever the markup
    // shipped stays, so a first visit is not overridden by this hook.
    if (stored === null) {
      this.el.setAttribute("aria-expanded", String(!on()));
    } else {
      this.apply(stored === "true");
    }

    this.onClick = () => this.apply(!on());
    this.el.addEventListener("click", this.onClick);

    this.syncAria = () => this.el.setAttribute("aria-expanded", String(!on()));
  },

  updated() {
    // The server never renders `aria-expanded` here -- the state is the
    // client's -- so a patch strips whatever was set on mount. Reassert it.
    this.syncAria();
  },

  destroyed() {
    this.el.removeEventListener("click", this.onClick);
  },
};
